var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('v-container',{staticClass:"text-center con_pos align-content-center"},[_c('img',{ref:"img-loader",staticClass:"me-3 img-loader v-responsive__sizer",attrs:{"src":require('../../assets/tarfih_log_hor.png'),"alt":"logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }